var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box6"},[_c('a',{on:{"click":_vm.openPop}},[_vm._v("添加老师，免费激活学习")])])}
var staticRenderFns = []

export { render, staticRenderFns }